<template>
  <base-container ref="container" :isLoading="loading" style="overflow: hidden">
    <base-container style="height: 100%">
      <el-descriptions
        :column="1"
        border
        size="small"
        :labelStyle="{ width: '100px', textAlign: 'center' }"
      >
        <el-descriptions-item label="排班周期">
          <el-row type="flex" align="middle">
            <el-input
              size="small"
              style="width: 170px"
              v-model="data.startDate"
              placeholder="开始日期！例:01-01"
            ></el-input>
            <span class="margin-h10">-</span>
            <el-input
              size="small"
              style="width: 170px"
              v-model="data.endDate"
              placeholder="结束日期！例:01-01"
            ></el-input>
          </el-row>
        </el-descriptions-item>
      </el-descriptions>
      <artisan-group title="排班规则">
        <template #header>
          <el-row type="flex" justify="space-between" align="middle">
            <span>排班规则</span>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-setting"
              @click="isShow = true"
            >
              设置时段排班
            </el-button>
          </el-row>
        </template>
        <WeekPeriodRule
          :data="schedules"
          @clearRule="clearRule"
          @editRule="editRule"
          @setRule="setRule"
        ></WeekPeriodRule>
      </artisan-group>
    </base-container>
    <artisan-dialog
      ref="drawer"
      title="排班规则设置"
      :visible.sync="isShow"
      height="90%"
      width="90%"
    >
      <WeekPeriodRuleSetting
        ref="ruleForm"
        v-if="isShow"
      ></WeekPeriodRuleSetting>
      <template #footer>
        <el-button
          type="danger"
          size="mini"
          icon="el-icon-close"
          @click="isShow = false"
        >
          取消
        </el-button>
        <el-button
          type="success"
          size="mini"
          icon="el-icon-check"
          @click="buildRules"
          >确认</el-button
        >
      </template>
    </artisan-dialog>
    <artisan-dialog
      ref="batchDialog"
      :title="batchDialog.title"
      :visible.sync="batchDialog.show"
      height="70%"
      width="90%"
    >
      <el-table
        border
        stripe
        :data="batchDialog.schedules"
        size="mini"
        highlight-current-row
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          header-align="center"
          type="selection"
          width="50"
        >
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="weekNo"
          label="星期"
          width="80"
        >
          <template slot-scope="{ row }">
            {{ getWeekLabel(row.weekNo) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="period"
          label="时段"
          width="100"
        >
          <template slot-scope="{ row }">
            {{ row.startPoint }}-{{ row.endPoint }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="totalCount"
          label="时段号源数"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="row.totalCount"
              @change="totalCountChange"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="totalCount"
          label="预留号源数"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="row.saveCount"
              @change="saveCountChange"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="signTime"
          label="签到时间"
          width="270"
        >
          <template slot-scope="{ row }">
            <el-time-select
              size="mini"
              style="width: 100px"
              placeholder="起始时间"
              v-model="row.signStart"
              @change="signStartChange"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
              }"
            >
            </el-time-select>
            <span class="margin-h10">-</span>
            <el-time-select
              size="mini"
              style="width: 100px"
              placeholder="结束时间"
              v-model="row.signEnd"
              @change="signEndChange"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
                minTime: row.signStart,
              }"
            >
            </el-time-select>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="clinicType"
          label="就诊类型"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-select
              size="mini"
              v-model="row.clinicType"
              @change="clinicTypeChange"
            >
              <el-option label="不限" value=""></el-option>
              <el-option label="门诊" value="outpatient"></el-option>
              <el-option label="住院" value="inpatient"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="appIds"
          label="授权渠道"
        >
          <template slot-scope="{ row }">
            <el-select
              style="width: 100%;"
              multiple
              collapse-tags
              size="mini"
              v-model="row.appIds"
              @change="appChange"
            >
              <el-option
                :label="app.label"
                v-for="app in appList"
                :key="app.value"
                :value="app.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button
          type="success"
          size="mini"
          icon="el-icon-check"
          @click="batchDialog.show = false"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
    <artisan-dialog
      ref="editDialog"
      :title="editDialog.title"
      :visible.sync="editDialog.show"
      height="70%"
      width="70%"
    >
      <ScheduleRuleForm
        ref="scheduleForm"
        v-if="editDialog.show"
        :data="editDialog.schedule"
      ></ScheduleRuleForm>
      <template #footer>
        <el-button
          type="danger"
          size="mini"
          icon="el-icon-close"
          @click="editDialog.show = false"
        >
          取消
        </el-button>
        <el-button
          type="success"
          size="mini"
          icon="el-icon-check"
          @click="confirmEdit"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { queryRule } from "@/api/jc/schedule";
import { loadEnum } from "@/api/sys/dicType";
import { getBelongTypeLabel, getWeekLabel } from "@/util/util";
import WeekPeriodRule from "./WeekPeriodRule.vue";
import WeekPeriodRuleSetting from "./WeekPeriodRuleSetting.vue";
import ScheduleRuleForm from "./ScheduleRuleForm.vue";

export default {
  components: {
    WeekPeriodRule,
    WeekPeriodRuleSetting,
    ScheduleRuleForm,
  },
  props: {
    id: [String, Number],
    type: String,
    scheduleRuleId: [String, Number],
  },
  data() {
    return {
      loading: false,
      weekNo: 0,
      isShow: false,
      editDialog: {
        show: false,
        title: "",
        schedule: {},
      },
      batchDialog: {
        show: false,
        title: "",
        schedules: [],
      },
      data: {
        belongType: this.type,
        belongId: this.id,
        startDate: "",
        endDate: "",
        details: [],
      },
      selectRows: [],
      appList: [],
    };
  },
  computed: {
    schedules() {
      let scheduleMap = {
        week1: [],
        week2: [],
        week3: [],
        week4: [],
        week5: [],
        week6: [],
        week7: [],
        week8: [],
        week0: [],
      };
      this.data.details.forEach((r) => {
        scheduleMap["week" + r.weekNo].push(r);
      });
      return [scheduleMap];
    },
  },
  created() {
    loadEnum("SysAppInfo").then((res) => {
      this.appList = res.data.data;
    });
    if (this.scheduleRuleId) {
      this.loadData();
    }
  },
  methods: {
    getBelongTypeLabel,
    getWeekLabel,
    handleSelectionChange(val) {
      this.selectRows = val;
    },
    signStartChange(val) {
      this.selectRows.forEach((c) => (c.signStart = val));
    },
    signEndChange(val) {
      this.selectRows.forEach((c) => (c.signEnd = val));
    },
    clinicTypeChange(val) {
      this.selectRows.forEach((c) => (c.clinicType = val));
    },
    totalCountChange(val) {
      this.selectRows.forEach((c) => (c.totalCount = val));
    },
    saveCountChange(val) {
      this.selectRows.forEach((c) => (c.saveCount = val));
    },
    appChange(val) {
      this.selectRows.forEach((c) => {
        c.appIds.splice(0, c.appIds.length, ...val);
      });
    },
    loadData() {
      this.loading = true;
      queryRule(this.scheduleRuleId)
        .then((res) => {
          this.loading = false;
          let data = res.data.data;
          data.details.forEach((c) => {
            c.appIds = c.appIds ? c.appIds.split(",") : [];
            c.ruleIds = c.ruleIds ? c.ruleIds.split(",") : [];
          });
          this.data = data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    clearRule(weekNo) {
      this.$refs.container.confirm({ msg: "确定清除排班规则?" }).then(() => {
        this.data.details = this.data.details.filter((c) => c.weekNo != weekNo);
      });
    },
    buildRules() {
      let ruleData = this.$refs.ruleForm.getRules();
      if (ruleData.periods.length) {
        let rules = [];
        ruleData.weekNos.forEach((w) => {
          ruleData.periods.forEach((p) => {
            rules.push({
              weekNo: w,
              startPoint: p.startPoint,
              endPoint: p.endPoint,
              clinicType: p.clinicType,
              totalCount: p.numCount,
              saveCount: p.saveCount,
              signStart: p.signStart,
              signEnd: p.signEnd,
              ruleIds: p.ruleIds,
              appIds: p.appIds,
            });
          });
        });
        let details = this.data.details.filter(
          (c) =>
            !(
              ruleData.weekNos.indexOf(c.weekNo.toString()) >= 0 &&
              ruleData.startTime <= c.startPoint &&
              ruleData.endTime >= c.endPoint
            )
        );
        details = details.concat(rules);
        details.sort((a, b) => (a.startPoint >= b.startPoint ? 1 : -1));
        this.data.details = details;
        this.isShow = false;
      } else {
        this.$message({
          type: "error",
          message: "请设置排班！",
        });
      }
    },
    editRule(data) {
      this.editDialog.schedule = data;
      this.editDialog.title = `${getWeekLabel(data.weekNo)} ${
        data.startPoint
      }-${data.endPoint}`;
      this.editDialog.show = true;
    },
    setRule(weekNo) {
      this.batchDialog.schedules = this.data.details.filter(
        (c) => c.weekNo == weekNo
      );
      this.batchDialog.title = `${getWeekLabel(weekNo)}--批量设置`;
      this.batchDialog.show = true;
    },
    confirmEdit() {
      let data = this.$refs.scheduleForm.getData();
      Object.assign(this.editDialog.schedule, data);
      this.editDialog.show = false;
    },
    getRule() {
      return this.data;
    },
  },
};
</script>

<style></style>
